<template>
	<div ref="idThumPan" style="float:left; background:#ffffff;">
		<div ref="idThum" style="border:0px solid blue;"></div>
	</div>
</template>

<script>

export default {
	name: 'ImgThum',
	components:{

	},
	props:['item', 'thW', 'thH'],
	data () {
		return {
			rate: 0,
			selfW: 0,
			selfH: 0,
		}
	},
	mounted: function(){
		this.selfW = this.$refs["idThum"].parentNode.offsetWidth;
		this.selfH = this.$refs["idThum"].parentNode.offsetHeight;

		let AreaW = this.thW;
		let AreaH = this.thH;

		let r1=this.item.width / this.item.height;
		let r2=AreaW / AreaH;

		if( r1 > r2 )
			 this.rate = AreaW / this.item.width;
		else this.rate = AreaH / this.item.height;

		let w=this.item.width * this.rate;
		let h=this.item.height* this.rate;

		this.$refs["idThumPan"].style["width"]  = (w)+"px";
		this.$refs["idThumPan"].style["height"] = (h)+"px";
		this.$refs["idThumPan"].style["margin-left"] = ((this.selfW-w)/2)+"px";
		this.$refs["idThumPan"].style["margin-top"]  = ((this.selfH-h)/2)+"px";

		let el=this.$refs["idThum"];
		el.style["width"]  = (w)+"px";
		el.style["height"] = (h)+"px";
		//el.style["margin-left"] = ((this.selfW-w)/2)+"px";
		//el.style["margin-top"]  = ((this.selfH-h)/2)+"px";
		el.style["background"]  = "url("+this.item.path+")";
		el.style["background-size"] = "100% 100%";
	},
	computed:{

	},
	methods:{

	}
}

</script>

<style scoped>


</style>



// WEBPACK FOOTER //
// ImgThum.vue?cc5fba34